import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

// Import payment fields
import CreditCardField from './elements/CreditCardField'
import CreditCardExpiryMonth from './elements/CreditExpiryFieldMonth'
import CreditCardExpiryYear from './elements/CreditExpiryFieldYear'
import CreditCvvField from './elements/CreditExpiryCvv'
import { BkFlowInput } from '../elements/BkFlowInput'

import yn from 'yn'
import _ from 'lodash'
import moment from 'moment'

// Payment form validation rules
const validate = (values, props) => {
	const {
		activeCreditCardType,
		availabilityData,
		configData,
		urlData,
	} = props
	const hotelLabels = _.get(configData, 'hotel.labels[0]', [])

	const errors = {}
	let luhnPatterns = null

	if (
		yn(process.env.REACT_APP_COMPONENT_ENABLE_CREDIT_CARD_LUHN_PATTERN_VALIDATION) &&
		urlData.promoCode &&
		availabilityData &&
		_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.partners') &&
		!_.isEmpty(availabilityData[0][0].basicPropertyInfo.viewExtensions.partners)
	) {
		const partnersData = availabilityData[0][0].basicPropertyInfo.viewExtensions.partners.filter(function (partner) {
			return String(partner.ratePlanId) === String(urlData.promoCode)
		})

		if (
			partnersData &&
			partnersData[0] &&
			!_.isEmpty(partnersData[0].validCreditCardPatterns)
		) {
			luhnPatterns = partnersData[0].validCreditCardPatterns
		}
	}

	if (!values.creditCard) {
		errors.creditCard = hotelLabels.ccCardRequiredError ? hotelLabels.ccCardRequiredError : '*required'
	} else if (
		activeCreditCardType &&
		String(activeCreditCardType) === 'amex' &&
		values.creditCard.length < 17
	) {
		errors.creditCard = hotelLabels.ccCardLengthShortError ? hotelLabels.ccCardLengthShortError : 'Must be longer than 15 characters'

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_CREDIT_CARD_LUHN_PATTERN_VALIDATION) &&
			values.creditCard.replace(/\s/g, '').length >= 4 &&
			!_.isEmpty(luhnPatterns)
		) {
			const validLuhnPattern = luhnPatterns.find(function(pattern){
				const userLuhnValue = values.creditCard.replace(/\s/g, '')
				return _.startsWith(Number(userLuhnValue), Number(pattern))
			})

			if (!validLuhnPattern) {
				errors.creditCard = hotelLabels.ccCardLuhnError ? hotelLabels.ccCardLuhnError : 'This is not a valid credit card type for the selected room rate.'
			}
		}
	} else if (
		activeCreditCardType &&
		String(activeCreditCardType) !== 'amex' &&
		values.creditCard.length < 19
	) {
		errors.creditCard = hotelLabels.ccCardLengthError ? hotelLabels.ccCardLengthError : 'Must be longer than 16 characters'

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_CREDIT_CARD_LUHN_PATTERN_VALIDATION) &&
			values.creditCard.replace(/\s/g, '').length >= 4 &&
			!_.isEmpty(luhnPatterns)
		) {
				const validLuhnPattern = luhnPatterns.find(function(pattern){
					const userLuhnValue = values.creditCard.replace(/\s/g, '')
					return _.startsWith(Number(userLuhnValue), Number(pattern))
				})

				if (!validLuhnPattern) {
					errors.creditCard = hotelLabels.ccCardLuhnError ? hotelLabels.ccCardLuhnError : 'This is not a valid credit card type for the selected room rate.'
				}
		}
	} else if (
		yn(process.env.REACT_APP_COMPONENT_ENABLE_CREDIT_CARD_LUHN_PATTERN_VALIDATION) &&
		values.creditCard.replace(/\s/g, '').length >= 4 &&
		!_.isEmpty(luhnPatterns)
	) {
		const validLuhnPattern = luhnPatterns.find(function(pattern){
			const userLuhnValue = values.creditCard.replace(/\s/g, '')
			return _.startsWith(Number(userLuhnValue), Number(pattern))
		})

		if (!validLuhnPattern) {
			errors.creditCard = hotelLabels.ccCardLuhnError ? hotelLabels.ccCardLuhnError : 'This is not a valid credit card type for the selected room rate.'
		}
	}

	if (!values.expirationMonth) {
		errors.expirationMonth = hotelLabels.ccExpiryRequiredError ? hotelLabels.ccExpiryRequiredError : '*required'
	}

	if (!values.expirationYear) {
		errors.expirationYear = hotelLabels.ccExpiryRequiredError ? hotelLabels.ccExpiryRequiredError : '*required'
	}

	if (values.expirationMonth && values.expirationYear) {
		const ccYear = moment(values.expirationYear, 'YY').format('YY')
		const ccMonth = moment(values.expirationMonth, 'MM').format('MM')
		const ccDay = moment(ccMonth, 'MM').endOf('month').format('DD')
		const ccExpiryDate = moment(`${ccDay}-${ccMonth}-${ccYear}`, 'DD-MM-YY').format('YYYY-MM-DD')

		if (moment(ccExpiryDate, 'YYYY-MM-DD').isBefore(moment(urlData.startDate, 'YYYY-MM-DD'))) {
			errors.expirationMonth = hotelLabels.ccExpiryError ? hotelLabels.ccExpiryError : 'Credit card expiration exceeds departure date.'
		}
	}

	if (!values.cvv) {
		errors.cvv = '*required'
	} else if (values.cvv.length < 3) {
		errors.cvv = 'Must be longer than 2 characters'
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_POSTAL_CODE) &&
		yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_POSTAL_CODE_REQUIRED) &&
		!values.postalCode
	) {
		errors.postalCode = '*required'
	}

	return errors
}

class CreditCardForm extends Component {
	render() {
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0]

		return (
			<form className="bk-flow-payment__credit-card-form">
				<div className="u-form-group start-sm group-credit-card">
					<Field
						name="creditCard"
						size="md"
						component={ CreditCardField }
						label={ hotelLabels.creditCardNumber }
					/>
				</div>

				<div className="u-form-group start-sm group-credit-expiration">
					<label className="u-form-label">*{ hotelLabels.expirationDate }</label>

					<Field
						name="expirationMonth"
						size="xxxs"
						component={ CreditCardExpiryMonth }
						label={ hotelLabels.formatMm }
					/>

					<span className="expiry-separator"></span>

					<Field
						name="expirationYear"
						size="xxxs"
						component={ CreditCardExpiryYear }
						label={ hotelLabels.formatYy }
					/>
				</div>

				<div className="u-form-group start-sm group-cvv">
					<Field
						name="cvv"
						size="xs"
						component={ CreditCvvField }
						label={ hotelLabels.securityCode }
					/>
				</div>

				{ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_POSTAL_CODE) &&
					<div className="u-form-group start-sm group-postal-code">
						<Field
							name="postalCode"
							type="text"
							size="md"
							component={ BkFlowInput }
							required={ yn(process.env.REACT_APP_COMPONENT_GUEST_FORM_POSTAL_CODE_REQUIRED) ? true : false }
							label={ hotelLabels.billingZipCode }
						/>
					</div>
				}
			</form>
		)
	}
}

export default reduxForm({
	validate,
	destroyOnUnmount: true,
	keepDirtyOnReinitialize: true
})(CreditCardForm)


// WEBPACK FOOTER //
// ./src/components/forms/creditCardForm/CreditCardForm.js